module.exports = __webpack_public_path__ + "img/changeWidth-1@2x.c1b5e90.png";